import { render, staticRenderFns } from "./polygonpoint.vue?vue&type=template&id=f44d7310&scoped=true"
import script from "./polygonpoint.vue?vue&type=script&lang=js"
export * from "./polygonpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44d7310",
  null
  
)

export default component.exports